<a class="dropdown-item" [class.disabled]="isDisabled" (click)="handleAction($event)" href="#">
  <i class="{{cssClass}}"></i>
  <span>{{label | translate}}</span>
</a>
